export default __webpack_public_path__ + "static/avatar-kayi-special-0-cover-69bc5d1207003418e430dfb2e9d60b50.png";